(function(app) {

    app.provider("icomplyApi",
    [
        function() {
            this.$get = [
                "crmApiGateway", function(crmApiGateway) {
                    var service = {};

                    service.getToken = function() {
                        return crmApiGateway.get("/iComply/Token");
                    }

                    return service;
                }
            ];
        }
    ]);
})(window.app); //jshint ignore:line